export default __webpack_public_path__ + "static/media/checkmark_blank.bd9fc8ea.svg";